<template>
  <footer class="main-footer">
    <div class="container-fluid d-flex justify-content-between small">
      <span>
        &copy; 2019.
        Host | Hostomate.com by
        <a href="https://www.inter-es.si" target="_blank">inter-es</a>
      </span>
      <span class="color-2">v0.1</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>
